import { CallModel, ContactTimelineStats } from '@/types';

export interface ContactTimelineModel {
    calls: CallModel[];
    stats: ContactTimelineStats;
}
